import * as jose from 'jose';
import { FlattenedJWSInput, GetKeyFunction, JSONWebKeySet, JWSHeaderParameters } from 'jose/dist/types/types';
import { UserIdentity } from 'ra-core';
import { Options, HttpError } from 'react-admin';
import axios, { AxiosResponse } from 'axios';
import { superAdminApiServer } from './config';

//import { Headers } from
const GooglePublicKeys = jose.createLocalJWKSet({
  keys: [
    {
      kty: 'RSA',
      alg: 'RS256',
      kid: '2650a2ce47b1ab3ba4099797f8c06ebc3de928ac',
      e: 'AQAB',
      n: 'yxRIhtcR01o3nb6hXnPj1U2FbNg6NoL2KGkJGB5QLWMV7qMdxvH_oOsP_sq71EnNXznmUc7FvK9RfoQxy1JGFM6gKzkI-wqXwFVhpCzWqW1pcczoJ8OTXtm1ltWO63KFyh2NpJ6KFOVInHqNoP8_QWwCE1_qfEQryeshv5hBPGgu3e6DuD9SzJ0hTGHrinbER8dxmrGcBrqeyvqMdDxAisYaPxNEOAThSIoGk5JuQ9dHWQtYZKfoy9vd0kVFnyHpss3pgEw4rn0efr_GmvF5V_JGrMkOaJsp8N_qpunWtH_A7XoPrjIw2A2NU_ZOevt07fzKZjws1d0HHmnHA7PWsw',
      use: 'sig'
    },
    {
      use: 'sig',
      n: 'nN6M3RHeDNE57lTiYTtXNnpADuEu1EmbBLPWzkTVAMLlxL5q-kbhUfMSW4rUDwQNaTmJtBfgqhTy-yUvT_DEs2v3ebW_Pw6csNTlaY6zvjPP4qvgRhC7xsPfU9pRWi8br_GBs7OYnWjjXa-Pfx9oRDOdRnSxqI9t44rbqB1E5n-VoeICQY2hHqmtWL2rOb-qdyYuWazTsDr7aXc_inBSf6SCA6ASWjQRy6Ijk1TWvUk1-yBz4gmp72AvhHRNMsY1VHxF5FsQrf2PhlrLZpOUR5Oy__24GAQhvB6Q1GJqnRCGwa0S12WuNJDjHBElYE6tluto5Q65bl525-a8ejDcpQ',
      kid: '1bd685f5e8fc62d758705c1eb0e8a7524c475975',
      e: 'AQAB',
      alg: 'RS256',
      kty: 'RSA'
    }
  ]
});

async function getCerts(): Promise<GetKeyFunction<JWSHeaderParameters, FlattenedJWSInput> | null> {
  const res = await axios.get<unknown, AxiosResponse<JSONWebKeySet>, unknown>('https://www.googleapis.com/oauth2/v3/certs');
  if (res.status === 200) {
    console.log('got remote JWT Keys', res.data);
    return jose.createLocalJWKSet(res.data);
  }
  return null;
}

export async function Login(JWTToken: string): Promise<boolean> {
  try {
    const certs = await getCerts();
    console.log(GooglePublicKeys);

    const googleAccountInfo = await jose.jwtVerify(JWTToken, certs ? certs : GooglePublicKeys);
    if (googleAccountInfo.payload) {
      console.log('Verified google account', googleAccountInfo);
      localStorage.setItem('GoogleIdToken', JWTToken);
      localStorage.setItem('GoogleAccountInfo', JSON.stringify(googleAccountInfo.payload));
      return true;
    }
  } catch (e) {
    console.error(e, 'Error with account validation');
    throw e;
  }
  return false;
}
export function Logout(): void {
  localStorage.removeItem('GoogleIdToken');
  localStorage.removeItem('GoogleAccountInfo');
}

export function isAuthenticated(): boolean {
  const googleAccountInfoJson = localStorage.getItem('GoogleAccountInfo');

  if (!googleAccountInfoJson) {
    console.log('isAuthenticated - Missing GoogleAccountInfo');
    return false;
  }
  const googleAccountInfo = JSON.parse(googleAccountInfoJson);
  const now = new Date();
  const isValid = now.getTime() > googleAccountInfo.exp * 1000 ? false : true;
  console.log('isAutheticated - Check expirey', isValid ? 'valid' : 'expired');
  return isValid;
}

export async function getIdentity(): Promise<UserIdentity | null> {
  const googleAccountInfoJson = localStorage.getItem('GoogleAccountInfo');
  const token = localStorage.getItem('GoogleIdToken');
  if (!googleAccountInfoJson) {
    console.log('getIdentity - Missing GoogleAccountInfo');
    return null;
  }
  const googleAccountInfo = JSON.parse(googleAccountInfoJson);
  const now = new Date();
  const isValid = now.getTime() > googleAccountInfo.exp * 1000 ? false : true;
  console.log('getIdentity - Check expirey', isValid ? 'valid' : 'expired');
  if (!isValid) {
    return null;
  }

  const res = await axios.get<unknown, AxiosResponse<any>, unknown>(`${superAdminApiServer}/admin/me`, { headers: { Authorization: `Bearer ${token}` } });
  const profile = {
    id: googleAccountInfo.sub,
    fullName: googleAccountInfo.name,
    avatar: googleAccountInfo.picture,
    adminUUID: res.data?.user?.adminUUID,
    ...googleAccountInfo
  } as UserIdentity;
  return profile;
}

export function getBearerToken() {
  const googleJWTToken = localStorage.getItem('GoogleIdToken') as string;
  return `Bearer ${googleJWTToken}`;
}

export function getProviderAuthOptions(): Options {
  return { user: { authenticated: isAuthenticated(), token: getBearerToken() } } as Options;
}

export function createHeadersFromOptions(options: Options): Headers {
  const requestHeaders = (options.headers ||
    new Headers({
      Accept: 'application/json'
    })) as Headers;
  if (!requestHeaders.has('Content-Type') && !(options && (!options.method || options.method === 'GET')) && !(options && options.body && options.body instanceof FormData)) {
    requestHeaders.set('Content-Type', 'application/json');
  }
  if (options.user && options.user.authenticated && options.user.token) {
    requestHeaders.set('Authorization', options.user.token);
  }

  return requestHeaders;
}

export async function getAuthProviderFetchJson(url: string, options: Options = {}) {
  const defaultOptions = getProviderAuthOptions();
  const requestHeaders = createHeadersFromOptions({ ...options, ...defaultOptions });

  const response = await fetch(url, { ...options, headers: requestHeaders });
  const text = await response.text();

  const status = response.status;
  const statusText = response.statusText;
  const headers = response.headers;
  const body = text;
  let json;
  try {
    json = JSON.parse(body);
  } catch (e) {
    // not json, no big deal
  }
  if (status < 200 || status >= 300) {
    return Promise.reject(new HttpError((json && (json.message as string)) || statusText, status as number, json));
  }
  return { status, headers, body, json };
}

//   const googleJWTToken = localStorage.getItem('GoogleIdToken') as string;
//   if (!options.headers) {
//     options.headers = new Headers({ Accept: 'application/json' });
//   }
//   // add your own headers here
//   options.headers.set('Authorization', `Bearer ${googleJWTToken}`);
//   return fetchUtils.fetchJson(url, options);
// }
// export function authHeader(url, options = { headers: Headers }) {
//   const googleJWTToken = localStorage.getItem('GoogleIdToken') as string;
//   if (!options.headers) {
//     options.headers = new Headers({ Accept: 'application/json' });
//   }
//   // add your own headers here
//   options.headers.set('Authorization', `Bearer ${googleJWTToken}`);
//   return fetchUtils.fetchJson(url, options);
// }
